import angular from 'angular';

import vcRecaptcha from "angular-recaptcha";
import angularInputMasks from 'angular-input-masks';
import angularUiMask from 'angular-ui-mask';
import uiBootstrap from 'angular-ui-bootstrap';

import login from './login/login';
import tokenEmail from './tokenEmail/tokenEmail';
import tokenSms from './tokenSms/tokenSms';
import question from './question/question';
import password from './password/password';
import success from './success/success';
import blockpassword from './blockpassword/blockpassword';

/**
 * Views main module
 */
let views = angular.module('app.components.views', [vcRecaptcha, angularInputMasks, angularUiMask, uiBootstrap, login, tokenEmail, tokenSms, question, password, blockpassword, success, ])
	.config(vcRecaptchaServiceProvider => {
		"ngInject";

		vcRecaptchaServiceProvider.setDefaults({
			key: '6LdhGlcUAAAAAGkqOjNF5AJ_UlBarNXUMepU3oZ1',
			theme: 'light',
			size: 'normal',
			type: 'image',
			lang: 'pt-BR'
		});
	})

	//comentar para parar desativar o redirecionamento automático para a home
	.run((uiMaskConfig, $transitions, Restangular, $state) => {
		"ngInject";
		uiMaskConfig.clearOnBlur = false;

		// Pseudo-Simple security.
		$transitions.onSuccess({to: '*'}, transition => {
			if ($state.current.name !== "login" && $state.current.name !== "blockpassword" && !Restangular.defaultHeaders.Authorization)
				$state.go("login");
		});
	});

export default views.name;


// WEBPACK FOOTER //
// ./src/app/components/views/views.js